import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './ThankYouModal.module.css';

const ThankYouModal = ({ show, handleClose, t }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <img src="/tick.png" alt="Success" className={styles.imgStyle} />
        <p className={styles.title}>{`${t('thankyou.title')}`}</p>
        <p className={styles.subTitle}>{`${t('thankyou.subTitle')}`}</p>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default ThankYouModal;
